import React, { useEffect, useState } from 'react';
import { t } from '@lingui/macro';
import ModalForm from 'components/modal/ModalForm';
import ItemTypeForm from 'components/forms/ItemTypeForm';

function ItemTypeModal(props) {
  const { title, modalTitle, hideButton, onSave, onClose, show, variant, ...rest } = props;
  const [showModal, setShowModal] = useState(!!show);
  const handleClose = () => {
    if (onClose) onClose();
    setShowModal(false);
  };
  const handleSave = () => {
    if (onSave) onSave();
    setShowModal(false);
  };
  const handleShow = (e) => {
    setShowModal(true);
  };

  useEffect(() => {
    setShowModal(show);
  }, [show]);

  return (
    <ModalForm
      variant={variant}
      show={showModal}
      handleClose={handleClose}
      handleShow={handleShow}
      title={modalTitle || t`New backlog item type`}
      buttonTitle={title || t`Add type`}
      hideButton={hideButton}>
      <ItemTypeForm {...rest} onSave={handleSave} onCancel={handleClose}></ItemTypeForm>
    </ModalForm>
  );
}
ItemTypeModal.defaultProps = {
  itemType: { name: '', color: '' }
};

export default ItemTypeModal;
